<template>
  <div :key="refreshTela">
    <v-flex p-t-30>
      <div class="tituloBox p-b-30 border-top">
        <div class="bg-primary barraTitulo"></div>
        <h1 class="text-info font-size-18">
          Qualificação
          <strong>Técnica</strong>
        </h1>
      </div>
    </v-flex>
    <div v-if="listaDocsExigidos.length">
      <v-layout row wrap p-b-10>
        <v-flex>
          <fieldset>
            <legend>
              <strong class="text-primary">Documentos Exigíveis da Família</strong>
            </legend>
            <v-layout row wrap>
              <v-flex
                style=" max-width: 110px;"
                class="infoValidade"
                v-bind:class="{'fValida':validaDocExigivelPorFamilia(familia.idFamiliaFornec)}"
                font-weight-black
                v-for="familia in model.familiaSolicitacao"
                :key="familia.idFamiliaFornec"
              >
                {{familia.codGrupo+'.'+familia.numFamilia}}
                <v-icon>check</v-icon>
              </v-flex>
            </v-layout>
          </fieldset>
        </v-flex>
      </v-layout>

      <div class="boxFamilias">
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px">
                <v-toolbar-title>
                  <strong>Documentos Exigíveis * (obrigatórios)</strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="openBox('exigidos')">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>
              <div v-show="isShow.exigidos">
                <v-flex
                  xs12
                  p-t-20
                  p-b-20
                  v-for="tipoDocumento in listaDocsExigidos"
                  :key="tipoDocumento.codGrupo+'_'+tipoDocumento.codDocumento"
                >
                  <fieldset>
                    <legend>
                      <strong class="text-primary">
                        {{tipoDocumento.nomDocumento}}
                      </strong>

                      <span class="text-primary" v-if="model.flagEstrangeiro == 1">
                          (OU DOCUMENTO EQUIVALENTE*)
                      </span>

                      <v-menu
                        v-model="info[tipoDocumento.codDocumento]"
                        :nudge-width="200"
                        offset-x
                      >
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>

                        <v-card class="boxInfoDoc">
                          <v-card-title class="pb-1">
                            <strong>Exigível para seguintes Famílias:</strong>
                          </v-card-title>

                          <v-list-tile-content
                            v-for="e in infoListaDoc(tipoDocumento)"
                            :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
                          >
                            <v-flex xs12 pb-1>
                              <strong>{{e.codGrupo+'.'+e.numFamilia}}</strong>
                              - {{e.descFamilia}}
                            </v-flex>
                          </v-list-tile-content>
                        </v-card>
                      </v-menu> <span v-html="ifNovoDocumento('qualificacaoTecnica',tipoDocumento.codDocumento)"></span>

                    </legend>

                    <v-layout wrap>
                      <v-flex xs6 sm4 md2>
                        <v-text-field
                          v-if="tipoDocumento.codDocumento != 109"
                          v-model="tipoDocumento.numDocumento"
                          :label="$t('label.numeroDocumento')+ ' *'"
                          :rules="validaIfObrigatorio(true)"
                          maxlength="30"
                          required
                          validate-on-blur
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.numDocumento,'numDocumento')"
                          persistent-hint
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs6 sm4 md2 v-if="tipoDocumento.nomDocumento != 'CARTA PATENTE SUSEP'">
                        <datePicker
                          v-if="tipoDocumento.codDocumento != 109 && tipoDocumento.codDocumento != 51 && tipoDocumento.codDocumento != 127"
                          v-model="tipoDocumento.dtVencimento"
                          :dataDefault="tipoDocumento.dtVencimento"
                          v-mask="maskData"
                          :rules="(model.flagEstrangeiro === '0' ) ? validacao.campoObrigatorio.concat([v=>v.length==10 || 'Data Inválida']) : [] "
                          :label="$t('label.dataValidade')+' *'"
                          required
                          validate-on-blur
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.dtVencimento,'dtVencimento',true)"
                          persistent-hint
                        />
                      </v-flex>

                      <v-flex xs12 sm4 md3>
                        <v-text-field
                          v-model="tipoDocumento.codControle"
                          maxlength="50"
                          :label="$t('label.codDeControle')"
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.codControle,'codControle')"
                          persistent-hint
                        ></v-text-field>
                      </v-flex>
                      <v-flex inputIcon xs12 sm12 md5 v-show="!tipoDocumento.file.novoUpload">
                        <!-- Anexo dos Documentos Exigíveis -->
                        <TextFieldValidadorDelete
                          :arquivoUpload="tipoDocumento.arquivoUpload"
                          :arquivoUploadSituacao="tipoDocumento.qualificacaoTecnicaSituacao"
                          :idMotivoIndeferimentoArquivo="tipoDocumento.idMotivoIndeferimentoArquivo"
                          :idMotivoIndeferimentoArquivo2="tipoDocumento.idMotivoIndeferimentoArquivo2"
                          :idMotivoIndeferimentoArquivo3="tipoDocumento.idMotivoIndeferimentoArquivo3"
                          :codDocumento="''+tipoDocumento.codDocumento"
                          :idFornecedor="model.numCgcFornecedor"
                          v-on:clear="iconDeleteExigiveis(tipoDocumento)"
                          v-on:aprovar="aprovar(tipoDocumento,2)"
                          v-on:rejeitar="rejeitar(tipoDocumento,$event)"
                          :label="$t('label.anexaDocumento')+ ' *'"
                          clearable
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.arquivoUpload,'arquivoUpload')"
                          persistent-hint
                        ></TextFieldValidadorDelete>
                        <v-dialog v-model="dialogExigiveis" max-width="355" :persistent="persistent">
                          <v-card>
                            <v-card-title class="headline">Atenção!</v-card-title>
                            <v-form>
                              <v-layout row wrap>
                                <v-flex xs12><br />
                                  Deseja excluir o documento?
                                </v-flex>
                              </v-layout><br /><br />
                              <v-layout wrap p-b-10>
                                <v-flex xs12 sm6>
                                  <v-btn @click="cancelarDialogExigiveis()">Não</v-btn>
                                </v-flex>
                                <v-flex xs12 sm6>
                                  <v-btn color="info" @click="apagarItemExigiveis()" :loading="isLoading">Sim</v-btn>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </v-card>
                        </v-dialog>
                      </v-flex>

                      <v-flex xs12 sm12 md5 v-if="tipoDocumento.file.novoUpload">
                        <uploadFile
                          tamanhoMaximo="20MB"
                          :required="(model.flagEstrangeiro === '0' ? tipoDocumento.file.novoUpload : false)"
                          :label="$t('label.anexaDocumento')+' *'"
                          v-model="tipoDocumento.file.arquivoUpload"
                          accept=".pdf, .PDF"
                        />
                      </v-flex>

                      <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                        *
                        <sub>
                          Conforme Lei nº 9.433/2005.
                        </sub>
                      </v-flex>

                    </v-layout>
                  </fieldset>
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div v-if="listaDocsElegiveis.length">
      <v-layout row wrap p-b-10>
        <v-flex>
          <fieldset>
            <legend>
              <strong class="text-primary">Documentos Elegíveis da Família</strong>
            </legend>
            <v-layout row wrap>
              <v-flex
                style=" max-width: 110px;"
                class="infoValidade"
                v-bind:class="{'fValida':validaDocElegivelPorFamilia(familia.idFamiliaFornec)}"
                font-weight-black
                v-for="familia in model.familiaSolicitacao"
                :key="familia.idFamiliaFornec"
                v-show="varificaSeTemElegiveis(familia.idFamiliaFornec)"
              >
                {{familia.codGrupo+'.'+familia.numFamilia}}
                <v-icon>check</v-icon>
              </v-flex>
            </v-layout>
          </fieldset>
        </v-flex>
      </v-layout>

      <div class="boxFamilias">
        <v-layout row wrap class="p-t-10 p-b-20">
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar light height="50px">
                <v-toolbar-title>
                  <strong>Documentos Elegíveis * (informe um documento por família)</strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="openBox('elegiveis')">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>
              <div v-show="isShow.elegiveis">
                <v-flex
                  xs12
                  p-t-20
                  p-b-20
                  v-for="tipoDocumento in listaDocsElegiveis"
                  :key="'Ele'-tipoDocumento.codGrupo+'_'+tipoDocumento.codDocumento"
                >
                  <fieldset>
                    <legend>
                      <strong class="text-primary">
                        {{tipoDocumento.nomDocumento}}
                      </strong>

                      <span class="text-primary" v-if="model.flagEstrangeiro == 1">
                          (OU DOCUMENTO EQUIVALENTE*)
                      </span>

                      <v-menu
                        v-model="info[tipoDocumento.codDocumento]"
                        :nudge-width="200"
                        offset-x
                      >
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>

                        <v-card class="boxInfoDoc">
                          <v-card-title class="pb-1">
                            <strong>Elegíveis para seguintes Famílias:</strong>
                          </v-card-title>

                          <v-list-tile-content
                            v-for="e in infoListaDoc(tipoDocumento)"
                            :key="'fe_'+e.codGrupo+'.'+e.numFamilia"
                          >
                            <v-flex xs12 pb-1>
                              <strong>{{e.codGrupo+'.'+e.numFamilia}}</strong>
                              - {{e.descFamilia}}
                            </v-flex>
                          </v-list-tile-content>
                        </v-card>
                      </v-menu> <span v-html="ifNovoDocumento('qualificacaoTecnica',tipoDocumento.codDocumento)"></span>
                    </legend>

                    <v-layout wrap>
                      <v-flex xs6 sm4 md2>
                        <v-text-field
                          v-model="tipoDocumento.numDocumento"
                          maxlength="30"
                          :label="$t('label.numeroDocumento')"
                          validate-on-blur
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.numDocumento,'numDocumento')"
                          persistent-hint
                        ></v-text-field>
                      </v-flex>
                      
                      <!-- Apresenta campo de validade se documento for diferente de CARTA PATENTE SUSEP -->
                      <v-flex xs6 sm4 md2 v-if="tipoDocumento.nomDocumento != 'CARTA PATENTE SUSEP'">
                        <datePicker
                          v-model="tipoDocumento.dtVencimento"
                          :dataDefault="tipoDocumento.dtVencimento"
                          v-mask="maskData"
                          :label="$t('label.dataValidade')"
                          
                          :validate-on-blur="true"
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.dtVencimento,'dtVencimento',true)"
                          persistent-hint
                        />
                      </v-flex>

                      <v-flex xs12 sm4 md3>
                        <v-text-field
                          v-model="tipoDocumento.codControle"
                          maxlength="50"
                          :label="$t('label.codDeControle')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex inputIcon xs12 sm12 md5 v-show="!tipoDocumento.file.novoUpload">
                        <!-- Anexo dos Documentos Elegíveis -->
                        <TextFieldValidadorDelete
                          :arquivoUpload="tipoDocumento.arquivoUpload"
                          :arquivoUploadSituacao="tipoDocumento.qualificacaoTecnicaSituacao"
                          :idMotivoIndeferimentoArquivo="tipoDocumento.idMotivoIndeferimentoArquivo"
                          :idMotivoIndeferimentoArquivo2="tipoDocumento.idMotivoIndeferimentoArquivo2"
                          :idMotivoIndeferimentoArquivo3="tipoDocumento.idMotivoIndeferimentoArquivo3"
                          :codDocumento="''+tipoDocumento.codDocumento"
                          :idFornecedor="model.numCgcFornecedor"
                          v-on:clear="iconDeleteElegiveis(tipoDocumento)"                          
                          v-on:aprovar="aprovar(tipoDocumento,2)"
                          v-on:rejeitar="rejeitar(tipoDocumento,$event)"
                          :label="$t('label.anexaDocumento')+ (ifBoxObrigatorio(tipoDocumento) ? ' *' : '')"
                          clearable
                          :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.arquivoUpload,'arquivoUpload')"
                          persistent-hint
                        ></TextFieldValidadorDelete>
                        <v-dialog v-model="dialogElegiveis" max-width="355" :persistent="persistent">
                          <v-card>
                            <v-card-title class="headline">Atenção!</v-card-title>
                            <v-form>
                              <v-layout row wrap>
                                <v-flex xs12><br />
                                  Deseja excluir o documento?
                                </v-flex>
                              </v-layout><br /><br />
                              <v-layout wrap p-b-10>
                                <v-flex xs12 sm6>
                                  <v-btn @click="cancelarDialogElegiveis()">Não</v-btn>
                                </v-flex>
                                <v-flex xs12 sm6>
                                  <v-btn color="info" @click="apagarItemElegiveis()" :loading="isLoading">Sim</v-btn>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md5
                        v-if="tipoDocumento.file.novoUpload"
                        :key="refreshcampo[tipoDocumento.codDocumento]"
                      >
                        <uploadFile
                          tamanhoMaximo="20MB"
                          :label="$t('label.anexaDocumento')"
                          v-model="tipoDocumento.file.arquivoUpload"
                          accept=".pdf, .PDF"
                        />
                      </v-flex>

                      <v-flex class="text-primary" v-if="model.flagEstrangeiro == 1">
                        *
                        <sub>
                          Conforme Lei nº 9.433/2005.
                        </sub>
                      </v-flex>

                    </v-layout>
                  </fieldset>
                </v-flex>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
 
    <!-- Relatório de vistoria com Nº Processo SEI e anexo --> 
    <div v-if="listaDocsNeutros.length">
      <div v-if="$verificaPerfilHabilitador()">
        <div class="boxFamilias">
          <v-layout row wrap class="p-t-10 p-b-20">
            <v-flex xs12>
              <v-card class="card--flex-toolbar">
                <v-toolbar light height="50px">
                  <v-toolbar-title>
                    <strong> {{ listaDocsNeutros[0].nomDocumento }}</strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>             
                <div v-show="isShow.neutros">
                  <v-flex
                    xs12
                    p-t-20
                    p-b-20 
                    v-for="tipoDocumento in listaDocsNeutros"
                    :key="'Neutro' + tipoDocumento.codDocumento"
                  >
                    <fieldset>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md4>
                          <v-text-field  
                            v-model="tipoDocumento.numDocumento"                       
                            maxlength="25"
                            :label="$t('label.numeroProcessoSEI') + ' *'"
                            persistent-hint
                            validate-on-blur                            
                            :rules=validaIfObrigatorioVistoria(true)                       
                            v-mask="maskNumSEI"
                          ></v-text-field>
                        </v-flex>

                        <v-flex inputIcon xs12 sm12 md8 v-show="!tipoDocumento.file.novoUpload">
                          <TextFieldValidadorDelete
                            :arquivoUpload="tipoDocumento.arquivoUpload"
                            :arquivoUploadSituacao="tipoDocumento.qualificacaoTecnicaSituacao"
                            :idMotivoIndeferimentoArquivo="tipoDocumento.idMotivoIndeferimentoArquivo"
                            :idMotivoIndeferimentoArquivo2="tipoDocumento.idMotivoIndeferimentoArquivo2"
                            :idMotivoIndeferimentoArquivo3="tipoDocumento.idMotivoIndeferimentoArquivo3"
                            :codDocumento="''+tipoDocumento.codDocumento"
                            :idFornecedor="model.numCgcFornecedor"                            
                            v-on:clear="iconDeleteVistoria(tipoDocumento)"
                            v-on:aprovar="aprovar(tipoDocumento,2)"
                            v-on:rejeitar="rejeitar(tipoDocumento,$event)"
                            :label="$t('label.anexaDocumento')+ ' *'"
                            clearable
                            :hint="ifQualificacaoAlterado(tipoDocumento.codDocumento,tipoDocumento.arquivoUpload,'arquivoUpload')"
                            persistent-hint                           
                          ></TextFieldValidadorDelete>
                          <v-dialog v-model="dialogVistoria" max-width="355" :persistent="persistent">
                            <v-card>
                              <v-card-title class="headline">Atenção!</v-card-title>
                              <v-form>
                                <v-layout row wrap>
                                  <v-flex xs12><br />
                                    Deseja excluir o documento?
                                  </v-flex>
                                </v-layout><br /><br />
                                <v-layout wrap p-b-10>
                                  <v-flex xs12 sm6>
                                    <v-btn @click="cancelarDialogVistoria()">Não</v-btn>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-btn color="info" @click="apagarItemVistoria()" :loading="isLoading">Sim</v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-form>
                            </v-card>
                          </v-dialog>
                        </v-flex>

                      <v-flex
                          xs12
                          sm12
                          md8
                          v-if="tipoDocumento.arquivoUpload === null"
                        >                          
                          <uploadFile
                            v-model="tipoDocumento.file.arquivoUpload"
                            tamanhoMaximo="20MB"
                            :label="$t('label.anexaDocumento') + ' *'"
                            accept=".pdf, .PDF"
                            :rules=validaIfObrigatorioVistoria(true,false)
                            :required=validaIfObrigatorioVistoria(true,true)
                          />
                        </v-flex>
                      </v-layout>
                    </fieldset>
                  </v-flex>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
    <!-- fim relatório de vistoria com Nº Processo SEI e anexo -->

  </div>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import qualificacaoTecnicaService from "../../../services/qualificacaoTecnicaService";
import analiseCampoAlterado from "./components/analiseCampoAlterado";
import TextFieldValidadorDelete from "../../../components/text-field-validador-delete.vue";
export default {
  name: "qualificacaoTecnicaForm",
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    erroQualificacaoTecnica: Object,
    fornecedorQualificacaoTecnicaVm: Object,
    listaDocsQualificacaoTecnica: Object,
    cadastroFornecedor: Function,
    OldModel: Object
  },
  mixins: [util, analiseCampoAlterado],
  components: {
    /*Componentes utilizados*/
    TextFieldValidadorDelete
  },

  created() /*Metodo de start do componente*/{
    this.getListaDocsQualificacaoTecnica();
  },
  watch: { //Propriedades assistidas
    "model.qualificacaoTecnica": {
      handler() {
        this.tableDoc = this.model.qualificacaoTecnica;
        this.getListaDocsQualificacaoTecnica();
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      dialogVistoria: false,
      dialogElegiveis: false,
      dialogExigiveis: false,
      valorRefVistoria: '',
      valorRefElegiveis: '',
      valorRefExigiveis: '',
      refreshcampo: [],
      info: [],
      arrayFamiliasDocumento: [],
      arrayDocsCadastrais: [],
      valid: true,
      isShow: { exigidos: true, elegiveis: true, neutros: true },
      listaDocsExigidos: [],
      listaDocsElegiveis: [],
      listaDocsNeutros: [],
      listaDocsVistoria: [],
      tableDoc: this.model.qualificacaoTecnica,
      refreshTela: 0,
      familiasPermitidasServTerc: ['01.98', '03.16', '03.25','03.29', '03.30', '04.56']
    };
  },

  methods: {//Declaracao de todos os metodos 
    iconDeleteVistoria(doc) {
      this.dialogVistoria = true;
      this.valorRefVistoria = doc;
    },

    cancelarDialogVistoria() {
      this.dialogVistoria = false;
    },

    apagarItemVistoria() {
      var aa = this.valorRefVistoria;
      
      aa.file.novoUpload = true; 
      aa.arquivoUpload = null;
      aa.file.arquivoUpload = null;
      aa.numDocumento = null;
      aa.dtVencimento = null;
      aa.codControle = null;
      aa.qualificacaoTecnicaSituacao = null;
      aa.idMotivoIndeferimentoArquivo = null;
      aa.idMotivoIndeferimentoArquivo2 = null;
      aa.idMotivoIndeferimentoArquivo3 = null;
      aa.dtRejeicao = null;
      this.updatedModel();
      this.dialogVistoria = false;
    },

    iconDeleteExigiveis(doc) {
      this.dialogExigiveis = true;
      this.valorRefExigiveis = doc;
    },

    cancelarDialogExigiveis() {
      this.dialogExigiveis = false;
    },

    apagarItemExigiveis() {
      var aa = this.valorRefExigiveis;
      
      aa.file.novoUpload = true; 
      aa.arquivoUpload = null;
      aa.file.arquivoUpload = null;
      aa.numDocumento = null;
      aa.dtVencimento = null;
      aa.codControle = null;
      aa.qualificacaoTecnicaSituacao = null;
      aa.idMotivoIndeferimentoArquivo = null;
      aa.idMotivoIndeferimentoArquivo2 = null;
      aa.idMotivoIndeferimentoArquivo3 = null;
      aa.dtRejeicao = null;
      this.updatedModel();
      this.dialogExigiveis = false;
    },

    iconDeleteElegiveis(doc) {
      this.dialogElegiveis = true;
      this.valorRefElegiveis = doc;
    },

    cancelarDialogElegiveis() {
      this.dialogElegiveis = false;
    },

    apagarItemElegiveis() {
      var aa = this.valorRefElegiveis;
      
      aa.file.novoUpload = true; 
      aa.arquivoUpload = null;
      aa.file.arquivoUpload = null;
      aa.numDocumento = null;
      aa.dtVencimento = null;
      aa.codControle = null;
      aa.qualificacaoTecnicaSituacao = null;
      aa.idMotivoIndeferimentoArquivo = null;
      aa.idMotivoIndeferimentoArquivo2 = null;
      aa.idMotivoIndeferimentoArquivo3 = null;
      aa.dtRejeicao = null;
      this.updatedModel();
      this.dialogElegiveis = false;
    },

    validaDocExigivelPorFamilia(idFamiliaFornec) {
      //metodo para validar os documentos exigiveis das familias que foram cadastradas
      var retorno = true;
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var exigido = this.listaDocsExigidos.filter(
            e => e.codDocumento === Dvalor.codDocumento
          );

          if (exigido.length) {
            var todos = this.testePeloMenos1QualificacaoTecnica(exigido);
            if (!todos) {
              retorno = false;
            }
          }
        });
      }
      return retorno;
    },

    // ticket 150183
    validaDocNeutroPorFamilia(idFamiliaFornec) {
      var retorno = true;
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var neutro = this.listaDocsNeutros.filter(
            e => e.codDocumento === Dvalor.codDocumento
          );

          if (neutro.length) {
            var todos = this.testePeloMenos1QualificacaoTecnica(neutro);
            if (!todos) {
              retorno = false;
            }
          }
        });
      }
      return retorno;
    },

    validaDocElegivelPorFamilia(idFamiliaFornec) {
      //metodo para verificae se existe pelo menos um documento elegivel para as familias cadastradas
      var retorno = false;
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var elegivel = this.listaDocsElegiveis.filter(
            e => e.codDocumento === Dvalor.codDocumento
          );

          var peloMenos1 = this.testePeloMenos1QualificacaoTecnica(elegivel);

          if (peloMenos1) {
            retorno = true;
          } else {
            var peloMenos1Exigivel = this.listaDocsExigidos.filter(
              x =>
                x.codDocumento === Dvalor.codDocumento && Dvalor.elegivel === "S"
            );

            peloMenos1Exigivel = this.testePeloMenos1QualificacaoTecnica(peloMenos1Exigivel);

            if (peloMenos1Exigivel) {
              retorno = true;
            }
          }
        });
      } else {
        retorno = true;
      }
      return retorno;
    },

    varificaSeTemElegiveis(idFamiliaFornec) {
      //verificar se tem documentos elegiveis
      var docs = this.retornaDocPorIdFamilia(idFamiliaFornec);
      var retorno = false;

      if (docs && docs.documentos) {
        docs.documentos.forEach(Dvalor => {
          var _elegivel = this.listaDocsElegiveis.find(
            e => e.codDocumento === Dvalor.codDocumento
          );
          if (_elegivel) retorno = true;
        });
      }

      return retorno;
    },
    retornaDocPorIdFamilia(idFamiliaFornec) {
      //retornar documento por id de familia
      return this.arrayFamiliasDocumento.find(
        x => x.idFamiliaFornec === idFamiliaFornec
      );
    },

    retornaDocsCadastraisPorId(idDocCadastrais) {
      return this.arrayDocsCadastrais.find(
        x => x.idDocCadastrais === idDocCadastrais
      );
    },

    infoListaDoc(tipoDocumento) {
      //retorna lista de documentos pela lista de familia
      var lista = this.arrayFamiliasDocumento.filter(item => {
        if (
          item.documentos.find(
            x => x.codDocumento === tipoDocumento.codDocumento
          )
        )
          return true;
        else return false;
      });
      return lista;
    },

    getListaDocsQualificacaoTecnica() {
      // Resgate dos possiveis documentos de qualificacao tecnica
      this.refreshTela += 1;

      this.fn_DocPorFamilia();

      this.listaExigidos();

      //this.listaNeutros();


      if(this.model.flagEstrangeiro === '1'){
        this.moveExigidosParaElegiveis();
      }
    },

    fn_DocPorFamilia() {
      //regate de documento por familia
      this.arrayFamiliasDocumento = [];

      this.model.familiaSolicitacao.forEach(item => {
        this.arrayFamiliasDocumento.push({
          idFamiliaFornec: item.idFamiliaFornec,
          descFamilia: item.familiaAssociada.descFamilia,
          codGrupo: item.codGrupo,
          numFamilia: item.numFamilia,
          documentos: this.listaDocsQualificacaoTecnica.lista.filter(
            x => x.codGrupo === item.codGrupo && x.numFamilia === item.numFamilia
          )
        });
      });
    },

    listaExigidos() {
      // Lista de documentos exigiveis
      var guarda = [];

    
       this.listaDocsExigidos = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          // #132793 - Cadastrar e Consultar Qualificacao Tecnica
          if (item.codDocumento === 109) return false;

        // 🆕 REGRA: Documento 180 só para Salvador/BA
            if (item.codDocumento === 180) {
              const ehSalvadorBA = this.model.codUf === "BA" && 
                                  this.model.endCidade && 
                                  this.model.endCidade.toUpperCase().trim() === "SALVADOR";
              if (!ehSalvadorBA) {
                return false; // Não exibe o documento 180 se não for Salvador/BA
              }
            }
          let documentoJaAnalisado = guarda.find(x => x.codDocumento === item.codDocumento);

          if (!documentoJaAnalisado && item.exigido === "S") {
            guarda.push(item);

            return true;
          } else {
            return false;
          }
        }
      );

      this.mergeListaQualificacaoFornecedor("exigidos");
      
      this.listaElegiveis();

      this.listaNeutros();

      this.fornecedorQualificacaoTecnicaVm.lista = this.listaDocsExigidos.concat(
        this.listaDocsElegiveis
      ).concat(
        this.listaDocsNeutros
      );
      
    },    

    listaNeutros() {

      this.listaDocsNeutros = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          if (item.codDocumento == 166 &&          
            item.elegivel === "N" && item.exigido === "N"
          ) {          
            return true;            
          } else {
            return false;
          }          
        }        
      );    

      for (let index = 0; index < this.familiasPermitidasServTerc.length; index++) {
        if(this.listaDocsNeutros.length > 1) {
          this.listaDocsNeutros.pop();
        }
      }    
      this.mergeListaQualificacaoFornecedor("neutros");           
    },

    listaElegiveis() {
      //lista de documentos elegiveis
      var guarda = [];
      this.listaDocsElegiveis = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          if (
            !guarda.find(x => x.codDocumento === item.codDocumento) &&
            !this.listaDocsExigidos.find(
              x => x.codDocumento === item.codDocumento
            ) &&
            item.elegivel === "S"
          ) {
            guarda.push(item);
            return true;
          } else {
            return false;
          }
        }
      );
      this.mergeListaQualificacaoFornecedor("elegiveis");
    },    

    mergeListaQualificacaoFornecedor(tipo) {
      //junção dos documentos de qualificacao tecnica do fornecedor
      if (tipo === "exigidos") {
        this.listaDocsExigidos.forEach((item, chave) => {
          //Valor Da Tabela

          var dec = {
            idFornecSolicitacao: this.model.idFornecSolicitacao,
            numDocumento: null,
            dtVencimento: null,
            arquivoUpload: null,
            codDocumento: null,
            codControle: null,
            qualificacaoTecnicaSituacao: null,
            idMotivoIndeferimentoArquivo: null,
            idMotivoIndeferimentoArquivo2: null,
            idMotivoIndeferimentoArquivo3: null,
            dtRejeicao: null,
            file: {
              arquivoUpload: null,
              novoUpload: true
            }
          };

          let tabelaDocFornec = this.tableDoc.find(
            x => x.codDocumento === item.codDocumento
          );

          if (tabelaDocFornec) {
            dec = this.preencherObjDaTabelaDocFornec(tabelaDocFornec);
          } else {
            dec.codDocumento = item.codDocumento;
          }
          item = Object.assign({}, item, dec);
          this.$set(this.listaDocsExigidos, chave, item);
        });
      } 
      
      if (tipo === "elegiveis") {
        this.listaDocsElegiveis.forEach((item, chave) => {
          //Valor Da Tabela

          var dec = {
            idFornecSolicitacao: this.model.idFornecSolicitacao,
            numDocumento: null,
            dtVencimento: null,
            arquivoUpload: null,
            codDocumento: null,
            codControle: null,
            qualificacaoTecnicaSituacao: null,
            idMotivoIndeferimentoArquivo: null,
            idMotivoIndeferimentoArquivo2: null,
            idMotivoIndeferimentoArquivo3: null,
            dtRejeicao: null,
            file: {
              arquivoUpload: null,
              novoUpload: true
            }
          };
          let tabelaDocFornec = this.tableDoc.find(
            x => x.codDocumento === item.codDocumento
          );

          if (tabelaDocFornec) {
            dec = this.preencherObjDaTabelaDocFornec(tabelaDocFornec);
          } else {
            dec.codDocumento = item.codDocumento;
          }
          item = Object.assign({}, item, dec);
          this.$set(this.listaDocsElegiveis, chave, item);
        });
      } 
      
      if (tipo === "neutros") {
        this.listaDocsNeutros.forEach((item, chave) => {
          //Valor Da Tabela

          var dec = {
            idFornecSolicitacao: this.model.idFornecSolicitacao,
            numDocumento: null,
            dtVencimento: null,
            arquivoUpload: null,
            codDocumento: null,
            codControle: null,
            qualificacaoTecnicaSituacao: null,
            idMotivoIndeferimentoArquivo: null,
            idMotivoIndeferimentoArquivo2: null,
            idMotivoIndeferimentoArquivo3: null,
            dtRejeicao: null,
            file: {
              arquivoUpload: null,
              novoUpload: true
            }
          };

          let tabelaDocFornec = this.tableDoc.find(
            x => x.codDocumento === item.codDocumento
          );

          if (tabelaDocFornec) {
            dec = this.preencherObjDaTabelaDocFornec(tabelaDocFornec);
          } else {
            dec.codDocumento = item.codDocumento;
          }
          item = Object.assign({}, item, dec);
          this.$set(this.listaDocsNeutros, chave, item);          
        });        
      }      
    },

    preencherObjDaTabelaDocFornec(tabelaDocFornec) {
      //preencher objeto para persitencia do mesmo na tabela de qualificacao tecnica
      return {
        idQualificacaoTecnica: tabelaDocFornec.idQualificacaoTecnica,
        idFornecSolicitacao: this.model.idFornecSolicitacao,
        numDocumento: tabelaDocFornec.numDocumento,
        dtVencimento: tabelaDocFornec.dtVencimento,
        arquivoUpload: tabelaDocFornec.arquivoUpload,
        codDocumento: tabelaDocFornec.codDocumento,
        codControle: tabelaDocFornec.codControle,
        qualificacaoTecnicaSituacao:
          tabelaDocFornec.qualificacaoTecnicaSituacao,
        idMotivoIndeferimentoArquivo: tabelaDocFornec.idMotivoIndeferimentoArquivo,
        idMotivoIndeferimentoArquivo2: tabelaDocFornec.idMotivoIndeferimentoArquivo2 || null,
        idMotivoIndeferimentoArquivo3: tabelaDocFornec.idMotivoIndeferimentoArquivo3 || null,
        dtRejeicao: tabelaDocFornec.dtRejeicao,
        file: {
          arquivoUpload: null,
          novoUpload: tabelaDocFornec.arquivoUpload ? false : true
        }
      };
    },

    temDocumentos(idFamiliaFornec, codGrupo, numFamilia) {
      //verificar se tem um documento elegivel para a familia
      var arr = this.arrayFamiliasDocumento.filter(
        f => f.idFamiliaFornec === idFamiliaFornec
      );
      if (arr.length) {
        arr = arr.filter(x =>
          x.documentos.find(
            d =>
              d.codGrupo === codGrupo &&
              d.numFamilia === numFamilia &&
              d.elegivel === "S"
          )
        );
      }
      if (arr.length) {
        return true;
      } else {
        return false;
      }
    },

    aprovar(itemLista) {     
      //aprovar o documento
      let model = Object.assign({}, itemLista);
      model.qualificacaoTecnicaSituacao = 2;
      model.idMotivoIndeferimentoArquivo = null;
      model.idMotivoIndeferimentoArquivo2 = null;
      model.idMotivoIndeferimentoArquivo3 = null;
      model.dtRejeicao = null;
      qualificacaoTecnicaService.aprovarRejeitar(model).then(() => {
        itemLista.qualificacaoTecnicaSituacao = 2;
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo', null);
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo2', null);
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo3', null);
        itemLista.dtRejeicao = null;
        this.updatedModel();
        this.refreshTela += 1;
        this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
      });
    },

    rejeitar(itemLista, motivo) {
      const selecao = motivo && typeof motivo === 'object'
        ? motivo
        : { motivoSelecionado: motivo, motivoSelecionado2: null, motivoSelecionado3: null };
      //rejeitar o documento
      let model = Object.assign({}, itemLista);
      model.qualificacaoTecnicaSituacao = 1;
      model.idMotivoIndeferimentoArquivo = selecao.motivoSelecionado;
      model.idMotivoIndeferimentoArquivo2 = selecao.motivoSelecionado2;
      model.idMotivoIndeferimentoArquivo3 = selecao.motivoSelecionado3;
      qualificacaoTecnicaService.aprovarRejeitar(model).then(response => { /*resposta do servico*/
        itemLista.qualificacaoTecnicaSituacao = 1;
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo', selecao.motivoSelecionado);
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo2', selecao.motivoSelecionado2);
        this.$set(itemLista, 'idMotivoIndeferimentoArquivo3', selecao.motivoSelecionado3);
        itemLista.dtRejeicao = response.data.dtRejeicao;
        model.dtRejeicao = response.data.dtRejeicao;
        this.updatedModel();
        this.refreshTela += 1;
        this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
      });
    },

    updatedModel() {
      //atualziar o model apos a persistencia
      var model = [];

      // Somente documentos persistidos ou com arquivo voltam para o model.
      // Itens do catálogo sem envio (apenas codDocumento) não devem ser gravados.
      this.fornecedorQualificacaoTecnicaVm.lista
        .filter(item => item && (item.idQualificacaoTecnica || item.arquivoUpload))
        .forEach(item => {
        model.push({
          idQualificacaoTecnica: item.idQualificacaoTecnica,
          idFornecSolicitacao: item.idFornecSolicitacao,
          numDocumento: item.numDocumento,
          dtVencimento: item.dtVencimento,
          arquivoUpload: item.arquivoUpload,
          codDocumento: item.codDocumento,
          codControle: item.codControle,
          qualificacaoTecnicaSituacao: item.qualificacaoTecnicaSituacao,
          idMotivoIndeferimentoArquivo: item.idMotivoIndeferimentoArquivo,
          idMotivoIndeferimentoArquivo2: item.idMotivoIndeferimentoArquivo2 || null,
          idMotivoIndeferimentoArquivo3: item.idMotivoIndeferimentoArquivo3 || null,
          dtRejeicao: item.dtRejeicao
        });
      });

      this.model.qualificacaoTecnica = model;
    },

    fnAcaoModalCancelar() {
      //cancelar  o rejeite do documento antes da peristencia
      this.modelDialogRejeitar.open = false;
    },

    ifBoxObrigatorio(box) {
      //verificar a obrigatoriedade
      var _box = [];

      _box.push(box);

      var peloMenos1CampoBox = this.testePeloMenos1CampoQualificacaoTecnica(_box);

      var validado = true;
      this.model.familiaSolicitacao.filter(familia => {
        if (this.varificaSeTemElegiveis(familia.idFamiliaFornec)) {
          if (!this.validaDocElegivelPorFamilia(familia.idFamiliaFornec)) {
            validado = false;
          }
        }
      });

      if (peloMenos1CampoBox || !validado) return true;
      else {
        return false;
      }
    },
    openBox(item) {
      //abrir o detalhamento do documento
      this.isShow[item] = !this.isShow[item];
    },
    baixarArquivo(arquivo) {
      //baixar o documento
      const numCgcFornecedor = this.$verificaPerfilCadastrador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g,"")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    moveExigidosParaElegiveis(){
      this.listaDocsElegiveis = this.listaDocsElegiveis.concat(this.listaDocsExigidos);
      this.listaDocsExigidos = [];
    },
    validaIfObrigatorio(validar) {
      //validar se é obrigatorio
      if(validar){
        if (this.model.flagEstrangeiro === '0' ) {
          return this.validacao.campoObrigatorio;
        } else {
          return [];
        }
      }else {
          return [];
      }
    },
    validaIfObrigatorioVistoria(validar,required) {
      //validar se é obrigatorio
      if (this.model.flagEstrangeiro === '0' ) {
      if(validar){
          if (this.model.flagEstrangeiro === '0' ) {
                var listaNeutrosvalidados = this.model.familiaSolicitacao.filter(element => 
                element.familiaFornecSituacao == "2" && 
( element.codGrupo == "01" && element.numFamilia == "98" || element.codGrupo == "03" && element.numFamilia == "16"
|| element.codGrupo == "03" && element.numFamilia == "25" || element.codGrupo == "03" && element.numFamilia == "30"
|| element.codGrupo == "04" && element.numFamilia == "56"          
));
             

               
                if(listaNeutrosvalidados.length > 0 )
                {
                  if(required) return true;
                  return this.validacao.campoObrigatorio;
                }
                else
                {
                  if(required) return false;
                  return [];
                }
            }
            else
                {
                  if(required) return false;
                  return [];
                }
        
            }
            else
                  {
                    if(required) return false;
                    return [];
                  }
      }
    
    }, 
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoValidade {
  opacity: 0.3;
}

.infoValidade.fValida {
  opacity: 1;
}

.infoValidade .v-icon {
  visibility: hidden;
}

.infoValidade.fValida .v-icon {
  color: #4caf50;
  visibility: visible;
}

.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}
.boxFamilias .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
}

.boxInfoDoc {
  font-size: 11px !important;
  color: #10618b;
}

.boxInfoDoc .v-card__title {
  font-size: 13px !important;
}
</style>
